module.exports = __webpack_public_path__ + "static/media/instructivoac3.eb32f177.png";